<template>
  <div class="modal-backdrop">
    <div class="card col-lg-3 col-md-8 mt-md-4 col-11 p-0 mx-auto" :class="{'confirmCard' :displayConfirmationModal}" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0" v-if="!displayConfirmationModal">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel">Report Job</h5><span class="fontsize10 font-italic black60 proximanova mt-2 ml-2" >This post is not relevent or offensive</span>          
          <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="line"></div>
        <div class="modal-body bodymodal11 bodymodal12">
          <span class="fontsize14 red proximanova">{{message}}</span>
          <div class="p-4">
            <div class="row opacityfont-12" >
              <form>
                <div class="form-check pb-2" v-for="(message,index) in reportmessages" :key="index" >
                  <label class="form-check-label" for="radio1">
                    <input type="radio" class="form-check-input check-with-label" :id="'radio1'+index"  v-model="checkedValue" checked name="radio1" :value="message.id" @click="handleClick(index)">
                    <!-- <span class="font14bold">{{message.indexDetailName}}</span> -->
                    <span class="d-flex flex-column">
                      <label class="proximanova-bold fontsize14 label-for-check mb-0" :id="'report-message'+index" @click="handleClick(index)">{{message.indexDetailName}}</label>
                      <div class="fontsize12 proximanova black60" v-if="index ===0">Misleading or repetitive posts</div> 
                      <div class="fontsize12 proximanova black60" v-else-if="index ===1">Violent images or promotion of violence</div> 
                      <div class="fontsize12 proximanova black60" v-else-if="index ===2">Sexually explicit content</div>
                      <div class="fontsize12 proximanova black60" v-else-if="index ===3">Prejudice, stereotypes, white supremacy, slurs</div>
                      <div class="fontsize12 proximanova black60" v-else-if="index ===4">Insults, threats, personally identifiable info</div>
                      <div class="fontsize12 proximanova black60" v-else>Health misinformation or conspiracies</div>
                    </span>
                  </label>                                      
                </div>
                <div class="row no-gutters d-flex flex-column p-3">
                  <label class="form-check-label" for="radio2">
                    <input type="radio" class="form-check-input check-with-label" :id="'radio2'"  v-model="checkedValue" checked name="radio2" :value="114" @click="addTextreport()">
                    <label class="proximanova-bold fontsize14 label-for-check" :id="'report-message'" @click="addTextreport()">Custom Report Message</label>
                    </label>
                  <div class="col d-flex justify-content-start align-items-center ">
                    <div class="form-group">                      
                      <textarea
                        class="form-control"
                        v-model="reportMessageText"
                        id="exampleFormControlTextarea1"                    
                        rows="5"
                        @input="addTextreport"
                        cols="77"
                        spellcheck="true"
                        maxlength="400"
                        placeholder="Repot Description (Optional)"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-end pr-3 pt-3 pb-2">
                  <a  class="btn button-create btn-color mr-2 close-button" id="follow" @click="close('NOTSUCCESS')">
                    <span class="fontsize16 black80 proximanova">Cancel</span>
                  </a>
                  <a   class="btn button-create borderradius20 mouseoverbtn2 backgroundcolorblack white" @click="openConfirmmodal" id="search">
                    <span class="bold16px_white proximanova">Report</span>
                  </a>
                </div> -->
              </form>                                                                       
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="mr-3 btn button-cancel1 black mouseoverbtn1 borderradius20" @click="close('NOTSUCCESS')">
            <span class="proximanova">Cancel</span>
          </button>
          <button class="mr-3 btn backgroundcolorblack white mouseoverbtn2 borderradius20 sign-up-button" @click="openConfirmmodal">
            <span class="button-create-font proximanova">Report</span>
          </button>
          </div>
      </div>
      <div class="modal-content border-0" v-if="displayConfirmationModal">
        <div class="modal-header delete-modal pb-0">
          <h5 class="modal-title fontsize18 black80 proximanova" id="deleteLikeVideoModalLabel">Are you sure you want to report on this job ?</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelConfirmmodal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body backgroundcolorwhite modal-delete text-center">
          <span class="button-cancel-font modaldeletebtn mouseoverbtn1 pointer border borderradius20 p-2 pr-4 pl-4 proximanova" @click="cancelConfirmmodal" data-dismiss="modal" aria-label="Close" >No</span>
          <button class="button-cancel-font backgroundcolorblack pointer mouseoverbtn2 white border p-1 ml-2 pr-4 pl-4 borderradius20 proximanova" :disabled="submitBtndisabled"  @click="reportjob()">Yes</button>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mouseoverbtn2 mt-4 p-1 borderradius20" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      Description : '',
      privacy : 'PUBLIC',
      videoplaying : false,
      profileId : null,
      videoId: null,
      reportmessages: [],
      reportMessageText: '',
      reportID: null,
      message : '',
      displayConfirmationModal : false,
      checkedValue : null,
      submitBtndisabled : false,
      displayAPIerrorModal : false,
    }
  },
  props : [
      'reportmessage'
  ],
  methods:{
    handleClick(ind){
      // this.reportID = this.reportmessages[ind].id; 
      this.checkedValue = this.reportmessages[ind].id;
      this.message = "";     
      this.reportMessageText = ''
    },
    addTextreport : function() {
      this.checkedValue = '114';
    },
    cancelConfirmmodal(){
      this.displayConfirmationModal = false;
      this.submitBtndisabled = false;
    },
    openConfirmmodal() {
      if(this.checkedValue) {
        this.displayConfirmationModal = true;
      }else{
        this.message = "Please select report reason before submit"
      }
    },
    // reporting on a particular job
    reportjob(){    
      var vm = this;
      this.submitBtndisabled = true;
      httpuserprofile.post('/userprofile/reportAJob?profileId='
      +this.reportmessage.currentuserId+'&companyProfileId='+this.reportmessage.profileId+'&jobId='+this.reportmessage.jobId+'&reasonId='+this.checkedValue+'&reasonDescription='+this.reportMessageText)
      .then((response) => {
          console.log("report job : ", response)
           this.submitBtndisabled = false;
          this.close('SUCCESS')
      }).catch((e) => {
          console.log(e.response)
          this.submitBtndisabled = false;
          this.displayAPIerrorModal = true;
          setTimeout(() => {
            vm.close('NOTSUCCESS') 
          }, 5000);
      })
    },
    close(type) {
        this.$emit('closereport', type);
      },
      //fetching report messages
    getReportMessages(){
      httpuserprofile
        .get("/userprofile/getListOfReasons")            
        .then(response => {              
          this.reportmessages = response.data.indexDetailsList;  
          console.log(this.reportmessages)            
        });   
    }

  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    console.log("reportMessageBob : ", this.reportmessage)
    this.getReportMessages();
  },

}

</script>

<style>
@import '../css/modal.css';
</style>